export default {
    server: 'Erreur de Serveur non specifiée',
    server2: "Nom d'utilisateur ou mot de passe non valides",
    notFound: {
        imagedObject: "L'Objet Image {id} est introuvable",
        edition: "L'Edition {id} est introuvable",
    }
};
